import request1 from '@/utils/request1';


// 获取操作日志列表
export function getOperationLogs(params) {
    return request1({
        url: `/traceability/operationLog`,
        method: 'post',
        data: params
    });
}

// 导出操作日志
export function exportOperationLogs(params) {
    return request1({
        url: `/traceability/operationLogExport`,
        method: 'post', // 统一使用POST请求
        data: params,   // 使用data而不是params
        responseType: 'blob'
    });
}

// 记录新的操作日志
export function createOperationLog(logData) {
    return request1({
        url: `/traceability/operationLogCreate`,
        method: 'post',
        data: logData
    });
}

// 为了向后兼容，保留原有的导出函数命名
export const getOperationLogsWithFullPath = getOperationLogs;
export const exportOperationLogsWithFullPath = exportOperationLogs;
export const logOperationWithFullPath = createOperationLog;

// 导出服务对象（可选，保持与之前版本的兼容性）
export default {
    getOperationLogs,
    exportOperationLogs,
    createOperationLog
};